<template>
  <div>
    <div id="reset-wrapper">
      <a @click="showConfirm = true"><img src="../../assets/images/icons/home.png" class="full-logo" /></a>
    </div>
    <ConfirmReset
      v-if="showConfirm"
      @close="showConfirm = false"
    ></ConfirmReset>
    <div class="m-background m-background--media-1"></div>
    <div class="l-container l-pad">
      <div class="survey">
        <p><strong>I feel the Leapskills game has helped my confidence about moving into shared accommodation:</strong></p>
        <div class="feedback">
          <div class="option1">
            <img src="../../assets/images/icons/agree.png" class="icon" />
            <a @click="answerFeedback('Agree')" class="m-btn__options">Agree</a>
          </div>
          <div class="option2">
            <img src="../../assets/images/icons/somewhat-agree.png" class="icon" />
            <a @click="answerFeedback('Somewhat agree')" class="m-btn__options">Somewhat agree</a>
          </div>
          <div class="option3">
            <img src="../../assets/images/icons/somewhat-disagree.png" class="icon" />
            <a @click="answerFeedback('Somewhat disagree')" class="m-btn__options">Somewhat disagree</a>
          </div>
          <div class="option4">
            <img src="../../assets/images/icons/disagree.png" class="icon" />
            <a @click="answerFeedback('Disagree')" class="m-btn__options">Disagree</a>
          </div>
        </div>
      </div>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MainFooter from '../../components/MainFooter'
import Brand from '../../components/Brand'
import ConfirmReset from '../../components/ConfirmReset'
export default {
  data () {
    return {
      showConfirm: false
    }
  },
  components: {
    MainFooter,
    Brand,
    ConfirmReset
  },
  methods: {
    ...mapActions(['updateFeedback']),
    answerFeedback (answer) {
      this.updateFeedback({ key: 'improvedConfidence', val: answer })
      this.$router.push({ name: 'survey1' })
    }
  },
  name: 'UserFeedback1'
}
</script>

<style scoped lang="scss">
p {
  font-size: 170%;
  width: 80%;
  margin: 10px auto;
}
.survey {
  margin-top: 100px;
  text-align: center;
}
.feedback {
  display: flex;
  flex-flow: space-between;
  justify-content: center;
  margin: 30px 0;
}
.m-btn__options {
  background: #a7dde0;
  margin: 0 10px;
  color: #000;
  /*box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);*/
  border-radius: 8px;
  &:hover {
    background: #6ec7cc;
  }
  &.disabled {
    cursor: not-allowed;
    background-color: lightgrey;
  }
}
.icon {
  margin: 0 auto 30px auto;
}

@media (max-width: 899px) {
  p {
    font-size: 170%;
    width: 70%;
    margin: 10px auto;
  }
  .m-btn__options {
    font-size: 120%;
    padding: 5px 10px;
  }
  .survey {
    margin-top: 35px;
    font-size: 70%;
  }
  .icon {
    margin: 0 auto 15px auto;
  }
  .feedback {
    margin: 15px 0;
  }
}
@media (min-width: 900px) {
  .m-btn__options {
    font-size: 130%;
    padding: 7px 15px;
  }
}
@media (min-width: 1200px) {
  .m-btn__options {
    font-size: 140%;
    padding: 10px 20px;
  }
}
a.m-btn__options {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Survey/UserFeedback1.vue